import { render, staticRenderFns } from "./MenuSelfService.vue?vue&type=template&id=9991d9b4&scoped=true"
import script from "./MenuSelfService.vue?vue&type=script&lang=js"
export * from "./MenuSelfService.vue?vue&type=script&lang=js"
import style0 from "./MenuSelfService.vue?vue&type=style&index=0&id=9991d9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9991d9b4",
  null
  
)

export default component.exports